import "@/businessLogicRegistry";
import { ConfigWrapper } from "@components/ConfigWrapper";
import { ThemeProvider } from "@/context/ThemeContext";
import "@/i18n";
import "@/styles/index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <ConfigWrapper />
    </ThemeProvider>
  </StrictMode>
);
